import type { Assistant } from '../types';

// Mock data for development
export const mockAssistants: Assistant[] = [
  {
    id: '05959338-06de-477d-9cc3-08369f8a1234',
    name: 'AI/Run FAQ',
    description: 'This is smart BrainIQ assistant which can help you with onboarding process. BrainIQ can answer to all you questions about capabilities, usage and so on.',
    author: 'System',
    likes: 17,
    comments: 0,
    totalUses: 9435,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Support'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: `You are smart chatbot and onboarding assistant of AI-empowered SDLC platform 'BrainIQ'.
Don't forget you name is "BrainIQ". You are a smart AI Agents & Assistants Platform.
Your main goals are onboard user with existing BrainIQ capabilities, use cases and help to use BrainIQ in general.
You don't have information about BrainIQ from your mind, so you must to search this context using knowledge base tool.
You must provide clear, step-by-step instructions on how user can onboard with BrainIQ platform, its key capabilities like code generation, code search, code review etc.`,
    conversationStarters: [
      'Tell me about BrainIQ platform.',
      'How to set up Jira integration in BrainIQ?',
      'How to create assistant in BrainIQ platform?',
    ],
    accessLinks: {
      details: '/assistants/05959338-06de-477d-9cc3-08369f8a1234',
      chat: '/chat/05959338-06de-477d-9cc3-08369f8a1234',
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a5678',
    name: 'AI/Run Chatbot',
    description: 'AI/Run Chatbot, the ultimate solution for real-time interactions. Designed to handle various queries and provide instant responses.',
    author: 'System',
    likes: 9,
    comments: 0,
    totalUses: 3829,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Support'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are an AI chatbot designed for real-time interactions.',
    conversationStarters: [
      'How can I help you today?',
      'What would you like to know?',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a9012',
    name: 'Prompt Engineer',
    description: 'I am an expert in creating highly effective, accurate, and optimized prompts for various AI models and use cases.',
    author: 'Vadym Vlasenko',
    likes: 37,
    comments: 1,
    totalUses: 2598,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Development'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are an expert prompt engineer specializing in creating optimized prompts.',
    conversationStarters: [
      'Help me write a better prompt',
      'How can I improve my prompt?',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a3456',
    name: 'AI/Run Feedback',
    description: 'BringIQ assistant to report bugs and improvements into BringIQ Jira. It analyzes user feedback and creates detailed reports.',
    author: 'System',
    likes: 5,
    comments: 0,
    totalUses: 393,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Support'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are a feedback collection assistant for BringIQ.',
    conversationStarters: [
      'I want to report a bug',
      'I have a suggestion for improvement',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a7890',
    name: 'BringIQ BA Assistant',
    description: 'Business Analyst Assistant. Used for creating Jira tickets in specified Jira projects based on user requirements.',
    author: 'System',
    likes: 6,
    comments: 0,
    totalUses: 294,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Business Analysis'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are a Business Analyst assistant that helps create Jira tickets.',
    conversationStarters: [
      'Create a new user story',
      'Help me write requirements',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a2345',
    name: 'Solution Architect Assistant',
    description: 'Expert Solution Architect Assistant with deep knowledge of enterprise architecture, cloud services, and best practices.',
    author: 'Vadym Vlasenko',
    likes: 12,
    comments: 0,
    totalUses: 272,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Architecture'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are an expert Solution Architect assistant.',
    conversationStarters: [
      'Help me design a system architecture',
      'Review my architecture design',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a6789',
    name: 'MCP FAQ',
    description: 'BringIQ onboarding chatbot assistant specializing in answering questions about Model Context Protocol.',
    author: 'Nikita Levyankov',
    likes: 3,
    comments: 0,
    totalUses: 156,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Support'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are an MCP FAQ assistant.',
    conversationStarters: [
      'What is MCP?',
      'How do I use MCP?',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: '05959338-06de-477d-9cc3-08369f8a0123',
    name: 'BringIQ Contributors Assistant',
    description: 'This is a smart BringIQ onboarding assistant that supports new BringIQ team members with documentation and guidelines.',
    author: 'System',
    likes: 4,
    comments: 0,
    totalUses: 189,
    isShared: true,
    sharedStatus: 'Marketplace',
    project: 'bringiq',
    categories: ['Support'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are a BringIQ Contributors onboarding assistant.',
    conversationStarters: [
      'How do I contribute to BringIQ?',
      'What are the coding guidelines?',
    ],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-12-01'),
  },
  {
    id: 'business-analyst-jira-001',
    name: 'Business Analyst Assistant Jira',
    description: 'Generates User Stories and creates Jira tickets based on user requirements. Perfect for agile teams.',
    author: 'Umapathi Sakirevupalle',
    likes: 2,
    comments: 0,
    totalUses: 45,
    isShared: false,
    sharedStatus: 'Not shared',
    project: 'bringiq',
    categories: ['Business Analysis'],
    llmModel: 'GPT-4.1 2025-04-14',
    systemInstructions: 'You are a Business Analyst assistant specialized in creating user stories and Jira tickets.',
    conversationStarters: [
      'Create a user story for me',
      'Help me write acceptance criteria',
    ],
    createdAt: new Date('2024-06-01'),
    updatedAt: new Date('2024-12-01'),
  },
];

export const mockChats = [
  { id: 'chat-1', title: 'New chat', assistantId: undefined },
  { id: 'chat-2', title: 'New chat', assistantId: undefined },
  { id: 'chat-3', title: 'New chat', assistantId: undefined },
  { id: 'chat-4', title: 'New chat', assistantId: undefined },
  { id: 'chat-5', title: 'New chat', assistantId: undefined },
  { id: 'chat-6', title: 'New chat', assistantId: undefined },
];

export const mockChatFolders = [
  {
    id: 'folder-1',
    name: 'AI/Run FAQ',
    assistantId: '05959338-06de-477d-9cc3-08369f8a1234',
    chats: [
      { id: 'folder-chat-1', title: 'New chat', assistantId: '05959338-06de-477d-9cc3-08369f8a1234' },
      { id: 'folder-chat-2', title: 'Tell me about BringIQ ...', assistantId: '05959338-06de-477d-9cc3-08369f8a1234' },
    ],
  },
  {
    id: 'folder-2',
    name: 'Business Analyst Assis...',
    assistantId: 'business-analyst-jira-001',
    chats: [],
  },
  {
    id: 'folder-3',
    name: 'Business Analyst Assis...',
    assistantId: 'business-analyst-jira-001',
    chats: [],
  },
];

export const mockCategories = [
  'Support',
  'Development',
  'Business Analysis',
  'Architecture',
  'Testing',
  'DevOps',
];
